module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/consultant-masai-b7faa30efb23db41219449ea4e0588d9.png";